export default __webpack_public_path__ + "static/media/dark.485fe321.svg";